import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { useMediaFetch } from '../hooks/useMediaFetch';
import { useInfiniteScroll } from '../hooks/useInfiniteScroll';
import MediaGrid from '../components/MediaGrid';
import { MediaFile } from '../components/MediaGrid';

const Container = styled.div`
  h3 {
    font-family: ralewayBold;
    font-weight: unset !important;
    font-size: 16px;
    line-height: 24px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    padding-bottom: 10px;
  }
`;

type EasyLlamaSectionProps = {
  onSelect: (file: MediaFile) => void;
};

const EasyLlamaSection: React.FC<EasyLlamaSectionProps> = ({ onSelect }) => {
  const { files, loading, fetchMedia, resetState } = useMediaFetch(
    'image',
    'easyllama'
  );
  const isRequestInProgress = useRef(false);

  const loadMore = async () => {
    if (isRequestInProgress.current) return;

    isRequestInProgress.current = true;
    try {
      const hasMore = await fetchMedia(page);
      setCanLoadMore(hasMore ?? false);
    } finally {
      isRequestInProgress.current = false;
    }
  };

  const {
    page,
    setPage,
    loadMoreRef,
    setCanLoadMore,
    isLoading: isInfiniteLoading
  } = useInfiniteScroll(loadMore);

  useEffect(() => {
    if (isRequestInProgress.current) return;

    isRequestInProgress.current = true;
    const init = async () => {
      try {
        resetState();
        setPage(1);
        setCanLoadMore(true);
        await loadMore();
      } finally {
        isRequestInProgress.current = false;
      }
    };

    init();
  }, []);

  return (
    <Container>
      <h3>EasyLlama Library</h3>
      <MediaGrid
        files={files}
        loading={loading || isInfiniteLoading}
        type="image"
        onSelect={onSelect}
        loadMoreRef={loadMoreRef}
        variant="long"
        showNoResults
      />
    </Container>
  );
};

export default EasyLlamaSection;
